// Shared by the React app and scripts/seo-build.js (CommonJS on purpose).
// Only verified information is used. No ratings, reviews, prices, awards or certifications.
const SITE = "https://formaxconnect.in";
const COMPANY = "FORMAX IT SOLUTIONS PRIVATE LIMITED";

const organization = () => ({
  "@type": "Organization",
  "@id": SITE + "/#organization",
  name: COMPANY,
  legalName: COMPANY,
  alternateName: "Formax Connect",
  brand: { "@type": "Brand", name: "Formax Connect" },
  description: "Formax Connect is a payment technology platform operated by " + COMPANY + ".",
  url: SITE,
  logo: SITE + "/assets/logo.png",
  foundingDate: "2018",
  address: {
    "@type": "PostalAddress",
    streetAddress: "N0060, Mochpole, Near JR School, Nabapally, Barasat",
    addressLocality: "Kolkata",
    addressRegion: "West Bengal",
    postalCode: "700126",
    addressCountry: "IN",
  },
  contactPoint: [
    { "@type": "ContactPoint", contactType: "customer support", email: "support@formaxconnect.in", areaServed: "IN", availableLanguage: "en" },
    { "@type": "ContactPoint", contactType: "sales", email: "partnership@formaxconnect.in", areaServed: "IN", availableLanguage: "en" },
  ],
});

const website = () => ({
  "@type": "WebSite",
  "@id": SITE + "/#website",
  name: "Formax Connect",
  url: SITE,
  inLanguage: "en-IN",
  publisher: { "@id": SITE + "/#organization" },
});

function buildSchema(route) {
  const url = SITE + (route.path === "/" ? "/" : route.path);
  const graph = [];
  if (route.path === "/") {
    graph.push(organization(), website());
    graph.push({ "@type": "WebPage", "@id": url + "#webpage", url, name: route.title, description: route.description, isPartOf: { "@id": SITE + "/#website" }, about: { "@id": SITE + "/#organization" } });
  } else {
    if (route.type === "about") graph.push({ "@type": "AboutPage", url, name: route.title, description: route.description, isPartOf: { "@type": "WebSite", name: "Formax Connect", url: SITE } });
    else if (route.type === "contact") graph.push({ "@type": "ContactPage", url, name: route.title, description: route.description, isPartOf: { "@type": "WebSite", name: "Formax Connect", url: SITE } });
    else graph.push({ "@type": "WebPage", url, name: route.title, description: route.description, isPartOf: { "@type": "WebSite", name: "Formax Connect", url: SITE } });
    graph.push({
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE + "/" },
        { "@type": "ListItem", position: 2, name: route.name, item: url },
      ],
    });
    if (route.service) {
      graph.push({
        "@type": "Service",
        name: route.name,
        serviceType: "Payment technology",
        description: route.description,
        url,
        provider: { "@type": "Organization", name: COMPANY, url: SITE },
        areaServed: { "@type": "Country", name: "India" },
      });
    }
  }
  return { "@context": "https://schema.org", "@graph": graph };
}

module.exports = { buildSchema, SITE };
